import React from 'react';

const Careers = () => {
  return (
    <div className="page">
      <h1>Careers</h1>
      {/* Content will be added later */}
    </div>
  );
};

export default Careers; 